import { IEventItem } from '../../../../store/player/events/store';
import { EventHomeHeights } from './EventHomeHeights';
export const getCheckoutHeight = (event: IEventItem) => {
  const { EVENTCHECKOUTBASE, ADDONSHEADER } = EventHomeHeights;
  return event.addons.length
    ? EVENTCHECKOUTBASE + ADDONSHEADER + 58 * event.addons.length
    : EVENTCHECKOUTBASE;
};
